/**
 * @file 编辑批次选项
 */

import { Button } from '@seiue/ui'
import { pick } from '@seiue/util'
import { Form, FormProps, Input, InputNumber } from 'antd'
import styled from 'styled-components'

import { Batch, BatchReq } from 'packages/sdks-next/growp'
import { EntryComponentsWrapper } from 'packages/theme'

/**
 * 编辑/新增 批次弹窗内容
 *
 * @param param - 参数
 * @param param.hide - 关闭弹窗
 * @param param.setBatchs - 设置当前批次方法
 * @param param.batchs - 当前所有批次
 * @param param.batch - 传入需要编辑的批次，如为空则说明当前是新增
 * @param param.batchIndex - 传入需要编辑的批次索引，如为空则说明当前是新增
 * @param param.outForm - 外部表单
 * @returns 组件
 */
export const EditOpenContent: React.FC<{
  hide: () => void
  setBatchs: (op: BatchReq[]) => void
  batchs: BatchReq[]
  batch?: Batch
  batchIndex?: number
  outForm?: FormProps['form']
}> = ({ hide, setBatchs, batchs, batch, batchIndex, outForm }) => {
  const [form] = Form.useForm()
  let initialValues = {}
  if (batch) {
    initialValues = {
      name: batch.name,
      quota: batch.quota,
      userCount: batch.userCount,
    }
  }

  const onSave = () => {
    form.submit()

    form.validateFields().then((values) => {
      const addOption = {
        ...pick(values, ['name', 'quota']),
        id: batch?.id,
        userCount: batch?.userCount,
      }
      if (batchIndex === undefined) {
        const saveOps = [addOption, ...batchs]
        setBatchs(saveOps)
        if (outForm !== undefined && batchs) {
          outForm.setFieldValue('batchs', saveOps)
        }
      } else {
        batchs[batchIndex] = addOption
        setBatchs([...batchs])
        if (outForm !== undefined && batchs) {
          outForm.setFieldValue('batchs', batchs)
        }
      }
      outForm?.validateFields(['batchs'])

      hide()
    })
  }

  return (
    <EntryComponentsWrapper>
      <Form
        form={form}
        initialValues={initialValues}
        layout="vertical"
        style={{ padding: '20px 20px 0 20px' }}
      >
        <Form.Item
          label="摇号标题"
          name="name"
          rules={[{ required: true, message: '请输入摇号标题' }]}
        >
          <Input
            placeholder="请输入"
            maxLength={200}
          />
        </Form.Item>
        <Form.Item
          label="中签名额"
          name="quota"
          rules={[{ required: true, message: '请输入中签名额' }]}
        >
          <InputNumber
            style={{ width: '160px' }}
            placeholder="请输入"
            min={0}
            max={10000}
          />
        </Form.Item>
      </Form>
      <FooterBox>
        <BtnBox>
          <Button onClick={() => hide()}>取消</Button>
          <Button
            type="primary"
            onClick={onSave}
          >
            确定
          </Button>
        </BtnBox>
      </FooterBox>
    </EntryComponentsWrapper>
  )
}

const FooterBox = styled.div`
  border-top: 1px solid ${(props) => props.theme.border.greyNormal};
  height: 56px;
  display: flex;
  justify-content: right;
  padding: 12px 20px;
`

const BtnBox = styled.div``
